import "./styles.css";

import { useLoaderData, useRouteError } from "react-router-dom";
import { useState } from "react";
import ResourceDisplay from "../../components/resource-display";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";
import ButtonClipboardCopy from "../../components/button-clipboard-copy/index";
import ButtonPrimary from "../../components/button-primary/index";
import ContactService from "../../service/contact/index";
import { SyncLoader } from "react-spinners";
import STYLES_CONSTANTS from "../../styles/index";
import background from "../../images/lines-background-element.svg";
import GenericErrorDisplay from "../generic-error";
import ResourceService from "../../service/resource";

export const path = "/contact/";

const resourceKeys = {
  element: "contact-banner-element",
  pageTitle: "contact-title",
  pageSubtitle: "contact-subtitle",
  address: "address",
  facebookUrl: "facebook-url",
  instagramUrl: "instagram-url",
  email: "contact-email",
  formTitle: "contact-form-title",
  formSubtitle: "contact-form-subtitle",
  successMessage: "contact-form-success",
  errorMessage: "contact-form-error",
};

export async function loader() {
  return await new ResourceService().read.byIds(Object.values(resourceKeys));
}

export function Component() {
  const resources = useLoaderData();

  const [color, setColor] = useState(null);
  const [resultMessage, setResultMessage] = useState(undefined);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  async function handleFormSubmit(e) {
    e.preventDefault();
    setResultMessage(null);

    const response = await new ContactService().create.message(
      name,
      email,
      title,
      message,
    );

    setColor(response === null ? "green" : "red");
    setResultMessage(
      response ?? `Response recorded. You will be contacted on <${email}>.`,
    );
  }

  return (
    <div id="page-contact">
      <div className="background">
        <img src={background} alt="" />
      </div>
      <div className="header">
        <div className="element-grafic">
          <ResourceDisplay resource={resources[resourceKeys.element]} />
        </div>
        <div className="text-container">
          <ResourceDisplay
            resource={resources[resourceKeys.pageTitle]}
            className="title"
            wrapper="h1"
          />
          <ResourceDisplay
            resource={resources[resourceKeys.pageSubtitle]}
            className="text"
          />
          <address>
            <FontAwesomeIcon icon={faLocationDot} size="xl" />
            <ResourceDisplay resource={resources[resourceKeys.address]} />
          </address>
          <div className="icons">
            <a href={resources[resourceKeys.facebookUrl]?.value}>
              <FontAwesomeIcon icon={faFacebookF} className="icon" />
            </a>
            <a href={resources[resourceKeys.instagramUrl]?.value}>
              <FontAwesomeIcon icon={faInstagram} className="icon" />
            </a>
            <ButtonClipboardCopy
              text={resources[resourceKeys.email]?.value}
              title="E-mail"
            >
              <FontAwesomeIcon icon={faEnvelope} className="icon" />
            </ButtonClipboardCopy>
          </div>
        </div>
      </div>
      <div className="body">
        <ResourceDisplay
          resource={resources[resourceKeys.formTitle]}
          className="title"
          wrapper="h2"
        />
        <ResourceDisplay
          resource={resources[resourceKeys.formSubtitle]}
          className="text"
          wrapper="h4"
        />
        <div className="content-container">
          <form>
            <label for="name">Nume</label>
            <input
              type="text"
              name="name"
              id="contact-form-name"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
            <label for="email">E-mail</label>
            <input
              type="text"
              name="email"
              id="contact-form-email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
            <label for="title">Titlu</label>
            <input
              type="text"
              name="title"
              id="contact-form-title"
              value={title}
              onChange={(event) => setTitle(event.target.value)}
            />
            <label for="message">Mesaj</label>
            <textarea
              name="message"
              id="contact-form-message"
              rows="10"
              value={message}
              onChange={(event) => setMessage(event.target.value)}
            />
            <div />
            <ButtonPrimary onClick={handleFormSubmit} className="submit">
              Trimite
            </ButtonPrimary>
            <div />
            <div style={{ color }}>
              {resultMessage === null ? (
                <SyncLoader color={STYLES_CONSTANTS["--color-fasmr-blue"]} />
              ) : (
                resultMessage
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
Component.displayName = "page-contact";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-contact-error";
